﻿$(document).ready(function () {
    /**********************************
    * See/Say Something
    */
    var sss_btn = "#see-say-link";
    var sss_timer = 0;
    var sss_delay = 6;
    var sss_cont = "#see-say-cont";
    var sss_tip = "#see-say-tip";

    function showSomething(sec) {
        if (sss_timer) {
            clearTimeout(sss_timer);
        }
        sss_timer = setTimeout(function () {
            $(sss_btn).addClass("active");
            hideSomething(sec);
        }, sec * 1000);
    }

    function hideSomething(sec) {
        if (sss_timer) {
            clearTimeout(sss_timer);
        }
        sss_timer = setTimeout(function () {
            sss_timer = 0;
            $(sss_btn).removeClass("active");
        }, sec * 1000);
    }

    $(document).on("click", "#see-say-link .cont .icons", function (e) {
        $(sss_btn).toggleClass("active");
        if ($(sss_btn).hasClass("active")) {
            hideSomething(sss_delay);
        }
    });

    $(document).on("click", "#see-say-cont .send-tip-btn", function (e) {
        $(sss_cont).fadeOut();
        $(sss_tip).fadeIn(1000);
    });

    showSomething(6);
    /*
     * See/Say Something
    **********************************/

    /**********************************
    * Newsletters
    */
    var news_btn = "#newsletters-link";
    var news_timer = 0;
    var news_delay = 6;

    function showNewsletters(sec) {
        if (news_timer) {
            clearTimeout(news_timer);
        }
        news_timer = setTimeout(function () {
            $(news_btn).addClass("active");
            hideNewsletters(sec);
        }, sec * 1000);
    }

    function hideNewsletters(sec) {
        if (news_timer) {
            clearTimeout(news_timer);
        }
        news_timer = setTimeout(function () {
            news_timer = 0;
            $(news_btn).removeClass("active");
        }, sec * 1000);
    }

    $(document).on("click", "#newsletters-link .cont .icons", function (e) {
        $(news_btn).toggleClass("active");
        if ($(news_btn).hasClass("active")) {
            hideNewsletters(news_delay);
        }
    });

    $(document).on("click", "#newsletters-link .cont .txt", function (e) {
        if ($(news_btn).hasClass("active")) {
            hideNewsletters(0);
        }
    });

    showNewsletters(6.1);
    /*
     * Newsletters
    **********************************/

    /*
     * DropDown Fix
     *******************/
    $(function () {
        setTimeout(function () {
            var windowSize = $(window).width();
            if (windowSize >= 1200) {
                $('.dropdown').hover(
                    function () {
                        $(this).addClass('open');
                    },
                    function () {
                        $(this).removeClass('open');
                    });
            }
            //
            $('.dropdown-menu .megamenu-col').css({ 'height': 'auto' });
        }, 500);
    });
});



// WEBPACK FOOTER //
// SignClient/assets/js/csp-script.js